import { PostAPI } from 'Components/Helper/Helpers';

export const CheckCIBILScore = async (request) => {
    return PostAPI(request, 'CIBILScore/CheckCIBILScore');
};

export const Select = async (request) => {
    return PostAPI(request, 'CIBILScore/Select');
};

export const SelectByID = async (request) => {
    return PostAPI(request, 'CIBILScore/SelectByID');
};

export const Update = async (request) => {
    return PostAPI(request, 'CIBILScore/Update');
};

export const CIBILDownloadPDF = async (request) => {
    return PostAPI(request, 'CIBILScore/CIBILDownloadPDF');
};
